/*
See this NUXT file
https://github.com/benshrimpton/sirdavis/blob/fe8cce8ae705d7bc68b5a7139a63edf053391740/components/Home/SectionFirst.vue#L84
*/
function swirlingLiquid() {

  var swirl = document.querySelector('.swirling-liquid');
  if (swirl == null) return;

  window.addEventListener('scroll', handleScroll);
  whenVideoHasLeftTheViewPort();

  function whenVideoHasLeftTheViewPort() {
    console.log('whenVideoHasLeftTheViewPort');
    const videoElement = document.getElementById('js-liquid-video');
    let lastScrollTop = 0;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio < 0.5) {
            videoElement.style.transform = 'translateY(0)';
            console.log('Video is less than 50% visible, fading out.');
          } else {
            videoElement.style.transform = 'translateY(-20%)';
            console.log('Video is more than 50% visible, fading in.');
          }
        });
      },
      {
        threshold: [0, 0.9, 1],
      },
    );

    window.addEventListener('scroll', () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      if (scrollTop > lastScrollTop) {
        observer.observe(videoElement);
        videoElement.style.transform = 'translateY(-20%)';
      } else {
        observer.unobserve(videoElement);
        videoElement.style.transform = 'translateY(0)';
        console.log('Video is more than 50% visible, fading in.');
      }
      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    });
  }

  function handleScroll() {
    console.log('HANDLE SCROl====');
    const innerVideoEl = document.querySelector(
      '.video-with-overlay__inner-vid',
    );
    if (innerVideoEl) {
      const rect = innerVideoEl.getBoundingClientRect();
      const distanceFromTop = rect.top;

      if (
        window.innerHeight > distanceFromTop &&
        distanceFromTop + innerVideoEl.offsetHeight > 0
      ) {
        let translateY = window.innerHeight - distanceFromTop;
        translateY = Math.max(0, Math.min(translateY, 0));
        innerVideoEl.style.transition = 'transform ease 1.5s';
        innerVideoEl.style.transform = `translateY(-${translateY}px)`;
      } else {
        innerVideoEl.style.transform = 'translateY(200px)';
      }
    }
  }
}

export default swirlingLiquid